import type { ISbLinkField } from '@nuxt-monorepo/ui/types';

export const isCurrentPageLink = (currentRoute: any, link: ISbLinkField) =>
    link?.url === currentRoute.path || link?.cached_url === currentRoute.path;
